<div class="pre-login-wrap">
  <div class="left-block">
    <div class="left-content-wrapper">
      <h1>Welcome to <br />Delm8 Corporate Cloud</h1>
      <div class="card-wrapper">
        <div class="w-33 content-card">
          <p>Call Us</p>
          <div class="inner-content">
            <mat-icon> call</mat-icon> 020 7070 0998
          </div>
        </div>
        <div class="w-33 content-card">
          <p>Email Us</p>
          <div class="inner-content">
            <mat-icon> mail_outline</mat-icon> info@delm8.co.uk
          </div>
        </div>

        <div class="w-33 content-card">
          <p>Follow Us</p>
          <div class="inner-content">
            <ul class="social-icons">
              <li>
                <a href="https://www.facebook.com/delm8" target="_blank"
                  ><img
                    src="/assets/images/icons/ic_round-facebook-white.svg"
                    alt="facebook"
                /></a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/delm8_mobile_app/"
                  target="_blank"
                  ><img
                    src="/assets/images/icons/ri_instagram-fill-white.svg"
                    alt="instagram"
                /></a>
              </li>
              <li>
                <a
                  href="https://www.youtube.com/watch?v=aBS8he0KIDw&t=11s"
                  target="_blank"
                  ><img
                    src="/assets/images/icons/mdi_youtube-white.svg"
                    alt="logo"
                /></a>
              </li>
              <li>
                <a href="https://twitter.com/delm83" target="_blank"
                  ><img
                    src="/assets/images/icons/mage_x-white.svg"
                    alt="twitter"
                /></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-bg">
      <img src="/assets/images/icons/regi-circle.png" alt="" />
    </div>
  </div>
  <div class="right-block">
    <div
      *ngIf="
        pathName === 'forgot-password' || pathName === 'forgot-password/admin';
        else elseBlock
      "
    >
      <div class="form-wrapper">
        <div class="title-wrapper">
          <h1>Forgot Password</h1>
          <h6 class="inner-content">
            Enter your email & we will send you a link to reset your password.
          </h6>
        </div>
        <form [formGroup]="forgetPasswordFrom" name="form">
          <app-input
            [label]="isAdmin ? 'Admin Email' : 'Email'"
            placeholder="mail@abc.com"
            type="email"
            [control]="forgetPasswordFrom.get('email')"
            [errorMessage]="getErrorMessage('email', 'forgetPassword')"
          ></app-input>
        </form>
        <button
          mat-flat-button
          class="primary-btn"
          disabled="{{ !forgetPasswordFrom.valid }}"
          (click)="forgotPassword()"
          [class.spinner]="loading"
          [disabled]="loading"
        >
          <ng-container *ngIf="!loading; else loadingTemplate">
            Proceed
          </ng-container>
          <ng-template #loadingTemplate>
            <mat-progress-spinner
              diameter="20"
              mode="indeterminate"
            ></mat-progress-spinner>
          </ng-template>
        </button>
        <div class="d-flex justify-content-center link-block">
          Go back to <a (click)="backToLogin()" class="link-primary">Login</a>
        </div>
      </div>
    </div>
    <ng-template #elseBlock>
      <div class="form-wrapper">
        <h1>Reset Password</h1>
        <form [formGroup]="resetPassword" name="form">
          <app-input
            label="New Password"
            type="password"
            placeholder="New Password"
            [control]="resetPassword.get('password')"
            [errorMessage]="getErrorMessage('password', 'resetPassword')"
          ></app-input>
          <app-input
            label="Confirm Password"
            placeholder="Confirm Password"
            type="password"
            [control]="resetPassword.get('confirm_password')"
            [errorMessage]="
              getErrorMessage('confirm_password', 'resetPassword')
            "
          ></app-input>
        </form>
        <button
          mat-flat-button
          class="primary-btn"
          disabled="{{ !resetPassword.valid }}"
          (click)="reset()"
          [class.spinner]="loading"
          [disabled]="loading"
        >
          <ng-container *ngIf="!loading; else loadingTemplate">
            Reset
          </ng-container>
          <ng-template #loadingTemplate>
            <mat-progress-spinner
              diameter="20"
              mode="indeterminate"
            ></mat-progress-spinner>
          </ng-template>
        </button>
      </div>
    </ng-template>
  </div>
</div>
